var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPsychiatry48Dp434343Fill0Wght400Grad0Opsz48 = function SvgPsychiatry48Dp434343Fill0Wght400Grad0Opsz48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "#434343",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450-130v-309h-20q-64 0-120.5-24.5T209-533t-66.5-104T120-760v-80h78.32Q260-840 317-815.5T419-746q33 34 54.5 76t30.5 89q7.65-11.9 16.82-22.95Q530-615 540-626q45-45 102-69.5T761.67-720H840v80q0 64-23.98 123T748-413q-45 45-101.56 69T528-320h-18v190zm1-370q0-61-20-113.5t-55-89-86-57T180-780q0 63 18.5 115.5T252-575q42 45 90.5 60T451-500m59 120q60 0 111-19.5t86-56 54-89T780-660q-60 0-111 20.5T583-583q-43 45-58 94t-15 109m-59-120"
  })));
};
export default SvgPsychiatry48Dp434343Fill0Wght400Grad0Opsz48;